var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notice',{class:_vm.$style.info__notice,attrs:{"text":_vm.text,"type":_vm.noticeType}},[_c('img',{attrs:{"src":require("@/assets/icons/info-notice.svg"),"alt":"info"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }